export default __webpack_public_path__ + "static/serverlessfirst-logo-full-af7c1cb2497b4467f2c27dfc81ff09a7.svg";